import { gql } from '@apollo/client';

export const UPDATE_FEED_PREFERENCES = gql`
    mutation updateFeedPreferences($userId: String!, $preferences: FeedPreferencesInput!) {
        updateFeedPreferences(userId: $userId, preferences: $preferences) {
            enabledFeedTypes
            feedTypeWeights {
                type
                weight
            }
            hideAuthors
            boostAuthors
            feedMode
            updatedAt
        }
    }
`;
